import riskApi from '@Apis/risks.api';
import { Category, ComponentMetadata, ComponentField } from '@Types';
import { InspectionStandardType } from '@Types/InspectionStandardType';

export const getLoFConfigApi = () => {
	const address = '/lof/config';
	return riskApi.get<Category[]>(address);
};

export const saveLoFApi = (config: Category[]) => {
	const address = '/lof/config';
	return riskApi.put<Category[]>(address, config);
};

export const getLoFFieldsApi = (assetType: string) => {
	const address = `/risk/fields?assetType=${assetType}&fieldType=lof`;
	return riskApi.get<ComponentField[], string>(address);
};

export interface GetLoFInspectionFieldsApiProps {
	assetType: string;
	inspectionStandard: InspectionStandardType;
}
export const getLoFInspectionFieldsApi = ({
	assetType,
	inspectionStandard,
}: GetLoFInspectionFieldsApiProps) => {
	const address = `/risk/fields?assetType=${assetType}&fieldType=${encodeURIComponent(
		'lof/inspection',
	)}&inspectionStandard=${inspectionStandard}`;
	return riskApi.get<ComponentField[], string>(address);
};

export const getLoFComponentInspectionMetadataApi = (
	assetType: string,
	param: string,
) => {
	const address = `/lof/inspection/score?assetType=${assetType}&fieldName=${param}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getLoFComponentAssetMetadataApi = (
	assetType: string,
	param: string,
) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${param}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getLoFComponentProximityAttrMetadataApi = (
	assetType: string,
	fieldName: string,
	layerName: string,
) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${fieldName}&layerName=${layerName}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getLoFComponentCustomTableMetadataApi = (
	assetType: string,
	fieldName: string,
	tableName: string,
) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${fieldName}&tableName=${tableName}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getLoFComponentTaskMetadataApi = (
	assetType: string,
	fieldName: string,
	tableName: string,
) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${fieldName}&taskType=${tableName}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getLoFComponentFailureDefinitionMetadataApi = (
	assetType: string,
	fieldName: string,
	failureDefinitionId: string,
) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${fieldName}&fieldType=failureDefinition&
		failureDefinitionId=${failureDefinitionId}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};

export const getLoFComponentDeteriorationModelMetadataApi = (
	assetType: string,
	fieldName: string,
	deteriorationModelId: string,
) => {
	const address = `/lof/field/score?assetType=${assetType}&fieldName=${fieldName}&fieldType=deteriorationModel&
		deteriorationModelId=${deteriorationModelId}`;
	return riskApi.get<ComponentMetadata[], string>(address);
};
